import { useState } from 'react';

import { Card } from '@mui/material';

import { useParams } from 'src/routes/hooks';

import { useTranslate } from 'src/locales';
import { PageOptions } from 'src/services/api.types';
import { useGetAccountsByOrganizationQuery } from 'src/services/admin/admin.service';

import { useTable } from 'src/components/table';

import GlobalAccountsTable from '../accounts/table/global-accounts-table';

const default_page: PageOptions = {
  page: 1,
  per_page: 20,
};

export default function GlobalOrganizationAccounts() {
  const table = useTable();

  const { t } = useTranslate();

  const { org_id } = useParams();

  const [pageOptions, setPageOptions] = useState<PageOptions>(default_page);

  const { currentData } = useGetAccountsByOrganizationQuery(
    {
      orgId: org_id as string,
      params: {
        ...pageOptions,
      },
    },
    { skip: !org_id }
  );

  const onChangePage = (_event: any, pageNumber: number) => {
    setPageOptions((prev) => ({ ...prev, page: pageNumber }));
  };

  const onChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPageOptions((prev) => ({ ...prev, per_page: parseInt(event.target.value, 10) }));
  };

  return (
    <Card>
      <GlobalAccountsTable
        accounts={currentData}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        currentPage={pageOptions}
      />
    </Card>
  );
}
